module.exports = __webpack_public_path__ + "static/media/simple-line-icons_user.924ce1bf.png";